// Version 1.0

import './lazy-load.less';

// https://github.com/verlok/lazyload
import LazyLoad from './vendor/lazyload.esm.js';

var lazyInstance = null,
	imageDimensions = [];

const defaultSettings = {
	log: 'none', // none, minimal, all
	threshold: 300,
	container: document,
	selector: ".lazy",
	selectorContainer: ".lazy-container",
	panels: false,
	panelSelector: '.lazy-scrolling-panel',
	loader: {
		selector: '.lazy-placeholder',
		html: '<span class="lazy-placeholder"></span>',
	},
	align: {
		selector: ".lazy-align",
	},
	eventClasses: {
		'loading': 'lazy-loading',
		'loaded': 'lazy-loaded',
		'error': 'lazy-error',
	},
};

const filterFloat = function (value) {
	if (/^(\-|\+)?([0-9]+(\.[0-9]+)?|Infinity)$/
		.test(value))
		return Number(value);
	return NaN;
}

const filterRatio = function (value) {
	return value.split(":");
}

const isVisible = function (el) {
	let box = el.getBoundingClientRect()
	if (box.width <= 0 || box.height <= 0) {
		return false;
	} else {
		return true;
	}
};

function log(eventName, el) {
	var item = null;
	if (typeof el != 'undefined') {
		if (el.getAttribute("data-src")) {
			item = el.getAttribute("data-src");
		} else {
			item = el;
		}
	}
	console.log(
		Date.now(),
		eventName,
		el,
	);
}

function getAlign(data) {
	let align = {
		width: 0,
		height: 0,
		left: 0,
		top: 0,
		x: data.align.indexOf('left') >= 0 ? 'left' : data.align.indexOf('right') >= 0 ? 'right' : 'center',
		y: data.align.indexOf('top') >= 0 ? 'top' : data.align.indexOf('bottom') >= 0 ? 'bottom' : 'middle',
		inset: data.align.indexOf('inset') >= 0 ? true : false,
		higher: null,
	}, procent;
	if (align.inset == true) {
		align.higher = true;
		procent = ((data.container.width * data.scale)) / data.orgine.width,
			align.width = (data.container.width * data.scale);
		align.height = Math.round(data.orgine.height * procent);
		if (align.height > data.container.height) {
			align.higher = false;
			procent = ((data.container.height * data.scale)) / data.orgine.height;
			align.width = Math.round(data.orgine.width * procent);
			align.height = (data.container.height * data.scale);
		}
	} else {
		align.higher = true;
		procent = (data.container.width * data.scale) / data.orgine.width;
		align.width = data.orgine.width * procent;
		align.height = data.orgine.height * procent;
		if (align.height < data.container.height) {
			align.higher = false;
			procent = (data.container.height * data.scale) / data.orgine.height;
			align.width = data.orgine.width * procent;
			align.height = data.orgine.height * procent;
		}
	}
	switch (align.y) {
		case 'top':
			align.top = 0;
			break;
		case 'middle':
			if (align.higher == true || data.scale != 1) {
				align.top = (data.container.height - align.height) / 2;
			} else {
				align.top = 0;
			}
			break;
		case 'bottom':
			if (align.higher == true || data.scale != 1) {
				align.top = data.container.height - align.height;
			} else {
				align.top = 0;
			}
			break;
	}
	switch (align.x) {
		case 'left':
			align.left = 0;
			break;
		case 'center':
			if (align.higher == false || data.scale != 1) {
				align.left = (data.container.width - align.width) / 2;
			} else {
				align.left = 0;
			}
			break;
		case 'right':
			if (align.higher == false || data.scale != 1) {
				align.left = data.container.width - align.width;
			} else {
				align.left = 0;
			}
			break;
	}
	return align;
}

function getImageDimensions(data, cb) {
	if (imageDimensions[data.src]) {
		cb(imageDimensions[data.src]);
	} else {
		let orgine,
			img = new Image();
		img.src = data.src;
		img.onload = () => {
			orgine = {
				width: img.naturalWidth,
				height: img.naturalHeight
			}
			img.onload = null; // clear memory
			img = null;
			imageDimensions[data.src] = orgine;
			cb(orgine);
		};
		img.onerror = () => {
			orgine = {
				width: data.$el.naturalWidth,
				height: data.$el.naturalHeight
			}
			imageDimensions[data.src] = orgine;
			cb(orgine);
		}
	}
}

function getSizes(data, cb) {
	data.container = {
		width: data.$container.clientWidth,
		height: data.$container.clientHeight
	}
	if (data.$el.nodeName.toLowerCase() == 'img' && data.ratio == false) {
		getImageDimensions(data, (orgine) => {
			data.orgine = orgine;
			cb(data);
		});
	} else {
		if (data.ratio != false) {
			data.orgine = {
				width: data.ratio[0],
				height: data.ratio[1]
			}
		} else {
			data.orgine = {
				width: data.$el.clientHeight,
				height: data.$el.clientWidth
			}
		}
		cb(data);
	}
}

function align(el, container) {
	let data = {
		$el: el,
		$container: container,
		align: (typeof container.dataset.align != undefined && typeof container.dataset.align != 'undefined') ? container.dataset.align : 'center',
		scale: (typeof container.dataset.scale != undefined && typeof container.dataset.scale != 'undefined') ? filterFloat(container.dataset.scale) : 1,
		ratio: (typeof container.dataset.ratio != undefined && typeof container.dataset.ratio != 'undefined') ? filterRatio(container.dataset.ratio) : false,
		src: el.currentSrc
	}
	if (data.align == 'false') {
		data.align = false;
	}
	if (data.ratio == 'false') {
		data.ratio = false;
	}
	if (data.align != false && isVisible(data.$el) && isVisible(data.$container)) {
		getSizes(data, (data) => {
			let align = getAlign(data);
			data.$el.style.width = `${align.width}px`;
			data.$el.style.height = `${align.height}px`;
			data.$el.style.transform = `translate(${align.left}px, ${align.top}px)`;
		});
	}
}

function resetImage(el, settings) {
	let container = el.closest(settings.selectorContainer);
	if (container != null) {
		let newEl = container.querySelector('img').cloneNode();
		newEl.src = '';
		newEl.srcset = '';
		newEl.classList.remove('lazy-error');
		newEl.removeAttribute('data-was-processed');
		container.querySelector('picture').replaceChild(newEl, el);
		return newEl;
	} else {
		return false;
	}
}

class Loader {
	constructor(settings) {
		if (typeof settings != 'undefined') {
			this.settings = settings;
			this.loader = this.create(settings);
		}
	}
	create(settings) {
		let setup = Object.assign(
			{},
			this.getDefaults(settings),
			this.getCallbacks(settings)
		);
		return new LazyLoad(setup);
	}
	destroy() {
		this.loader.destroy();
	}
	update() {
		this.loader.update();
	}
	getDefaults(settings) {
		return {
			container: settings.container,
			elements_selector: settings.selector,
			threshold: settings.threshold,
			class_loading: settings.eventClasses.loading,
			class_loaded: settings.eventClasses.loaded,
			class_error: settings.eventClasses.error,
			load_delay: 0,
			auto_unobserve: true,
			use_native: true,
		}
	}
	getCallbacks(settings) {
		return {
			callback_enter: (el) => {
				let container = el.closest(settings.selectorContainer);
				this.addLoader(el, container);
				if (settings.log == 'all') {
					log("🔑 ENTERED", el);
				}
			},
			callback_exit: (el) => {
				if (settings.log == 'all') {
					log("🚪 SKIPPED", el);
				}
			},
			callback_reveal: (el) => {
				if (el.classList.contains('lazy-bg')) {
					let container = el.closest(settings.selectorContainer);
					this.show(el, container);
				}
				if (settings.log == 'all') {
					log("👁️ REVEALED", el);
				}
			},
			callback_loaded: (el) => {
				let container = el.closest(settings.selectorContainer);
				if (container) {
					container.classList.remove("has-404");
				}
				this.align(el, container);
				this.show(el, container);
				el.addEventListener("load", () => {
					this.align(el, container);
				});
				if (settings.log == 'all' || settings.log == 'minimal') {
					log("👍 LOADED", el);
				}
			},
			callback_error: (el) => {
				let container = el.closest(settings.selectorContainer);
				if (container) {
					container.classList.add("has-404");
				}
				if (settings.log == 'all' || settings.log == 'minimal') {
					log("💀 ERROR", el);
				}
			},
			callback_finish: () => {
				if (settings.log == 'all' || settings.log == 'minimal') {
					log("✔️ All images are loaded");
				}
			}
		}
	}
}

class PanelLoader extends Loader {
	constructor(settings) {
		super(settings);
		this.instances = [];
	}
	create(settings) {
		let setup = Object.assign(
			{},
			this.getDefaults(settings),
			{
				elements_selector: settings.panelSelector,
				callback_enter: (el) => {
					if (settings.log == 'all' || settings.log == 'minimal') {
						log("👍 PANEL LOADED", el);
					}
					this.createInstance(el, settings);
				}
			}
		)
		return new LazyLoad(setup);
	}
	destroy() {
		this.loader.destroy();
		for (let key in this.instances) {
			let instance = this.instances[key];
			instance.destroy();
		}
		this.loader.destroy();
	}
	update() {
		this.loader.update();
		for (let key in this.instances) {
			let instance = this.instances[key];
			instance.update();
		}
		this.loader.update();
	}
	createInstance(el, settings) {
		let setup = Object.assign(
			{},
			this.getDefaults(settings),
			this.getCallbacks(settings),
			{
				container: el,
				elements_selector: settings.selector
			}
		);
		let instance = new LazyLoad(setup);
		this.instances.push(instance);
	}
}

Loader.prototype.addLoader = function (el, container) {
	if (container && !container.querySelector(this.settings.loader.selector)) {
		container.insertAdjacentHTML('afterbegin', this.settings.loader.html);
	}
};

Loader.prototype.align = function (el, container) {
	if (container && container.classList.contains(this.settings.align.selector.replace('.', ''))) {
		align(el, container);
	}
};

Loader.prototype.show = function (el, container) {
	if (container) {
		container.classList.add("is-active");
		setTimeout(() => {
			if (container.querySelector(this.settings.loader.selector) != null) {
				container.querySelector(this.settings.loader.selector).remove();
			}
		}, 1000);
	}
};

class Lazy {
	constructor(customSettings) {
		if (!lazyInstance) {
			this.settings = Object.assign({}, defaultSettings, customSettings);
			this.instances = [];
			this.create();
			lazyInstance = this;
		} else {
			return lazyInstance;
		}
	}
}

Lazy.prototype = {
	create() {
		let created = false;
		if (typeof this.instances['default'] == 'undefined') {
			this.instances['default'] = new Loader(this.settings);
			created = true;
		}
		if (this.settings.panels == true && typeof this.instances['panels'] == 'undefined') {
			this.instances['panels'] = new PanelLoader(this.settings);
			created = true;
		}
		if (created == true) {
			if (this.settings.log == 'all' || this.settings.log == 'minimal') {
				log("✔️ CREATED LAZY LOAD");
			}
		} else {
			if (this.settings.log == 'all' || this.settings.log == 'minimal') {
				log("✔️ ALREADY CREATED");
			}
		}
	},
	update() {
		for (let key in this.instances) {
			this.instances[key].update();
		}
		if (this.settings.log == 'all' || this.settings.log == 'minimal') {
			log("✔️ UPDATED LAZY LOAD");
		}
	},
	destroy() {
		for (let key in this.instances) {
			this.instances[key].destroy();
			delete this.instances[key];
		}
		if (this.settings.log == 'all' || this.settings.log == 'minimal') {
			log("💀 DESTROYED LAZY LOAD");
		}
	},
	load(el) {
		for (let key in this.instances) {
			var _this = this.instances[key].loader;
			_this.load(el);
		}
	},
	loadAll() {
		for (let key in this.instances) {
			var _this = this.instances[key].loader;
			_this.loadAll();
		}
	},
	loadImageAfter404(el) {
		el = resetImage(el, this.settings);
		if (el != false) {
			window.lazy.load(el);
		}
	},
	resize(container) {
		let el = container.querySelector(this.settings.selector);
		align(el, container);
	},
	resizeAll() {
		document.querySelectorAll(this.settings.align.selector).forEach((container) => {
			let el = container.querySelector(this.settings.selector);
			if (container && container.classList.contains('is-active')) {
				align(el, container);
			}
		});
	}
}

const init = Lazy;

export { init };
